import FloorPlanModeToggle from '../../../components/FloorPlanModeToggle.jsx';

/**
 * @param {{
 *   mode: '2d' | '3d';
 *   onChange: (mode: '2d' | '3d') => void;
 *   disabled?: boolean;
 * }} props
 */
function ViewModeSwitcher({ mode, onChange, disabled = false }) {
  if (disabled) return null;
  return (
    <div className="floor-plan-workspace-view-switcher card">
      <FloorPlanModeToggle mode={mode} onChange={onChange} />
    </div>
  );
}

export default ViewModeSwitcher;
